import React from 'react';
import PropTypes from 'prop-types';
import SelectionSingleSelectGroup from '@/components/ui/SelectionSingleSelectGroup';
import DisclosureFilter from '@/forms/_fields_v2/DisclosureFilter';
import NumberFilter from '@/forms/_fields_v2/NumberFilter';

export default function DisclosureNumberFilter(props) {
  const {
    label,
    operatorValue,
    onOperatorChange,
    numberValue,
    onNumberChange,
    numberLabel,
    numberDescription,
    icon,
    minNumber = 0,
    stepIncrement = 5,
    options = ['exactly', 'at least', 'at most'],
  } = props;

  return (
    <DisclosureFilter
      label={label}
      value={[numberValue]}
    >
      <SelectionSingleSelectGroup
        label="With ..."
        value={operatorValue}
        onChange={onOperatorChange}
        options={options}
      />
      <NumberFilter
        label={numberLabel}
        description={numberDescription}
        value={numberValue}
        onChange={onNumberChange}
        minNumber={minNumber}
        stepIncrement={stepIncrement}
        icon={icon}
      />
    </DisclosureFilter>
  );
}

DisclosureNumberFilter.propTypes = {
  label: PropTypes.string.isRequired,
  operatorValue: PropTypes.string,
  onOperatorChange: PropTypes.func.isRequired,
  numberValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onNumberChange: PropTypes.func.isRequired,
  numberLabel: PropTypes.string,
  numberDescription: PropTypes.string,
  icon: PropTypes.elementType,
  minNumber: PropTypes.number,
  stepIncrement: PropTypes.number,
  options: PropTypes.arrayOf(PropTypes.string),
};
